import { User } from '../core/_models';
import { AccountFast } from '../core/_models_fast';

/**
 * Check if the user is affected by an agency payment issue.
 * Returns true if either:
 * 1. The user belongs to an agency with payment_out_of_date
 * 2. The current account belongs to an agency with payment_out_of_date
 */
export function isPaymentOutOfDate(
    currentUser: User | null | undefined,
    currentAccount: AccountFast | null | undefined
): boolean {
    // Check if user's agency has payment out of date
    const userAgencyOutOfDate = currentUser?.belongs_to_agency?.payment_out_of_date === true;

    // Check if current account's agency has payment out of date
    const accountAgencyOutOfDate = currentAccount?.belongs_to_agency?.payment_out_of_date === true;

    return userAgencyOutOfDate || accountAgencyOutOfDate;
}

/**
 * Get the agency name for display in payment messages.
 * Returns the agency name from either the user or account, whichever is available.
 */
export function getAgencyName(
    currentUser: User | null | undefined,
    currentAccount: AccountFast | null | undefined
): string {
    // Prefer user's agency name if available
    if (currentUser?.belongs_to_agency?.name) {
        return currentUser.belongs_to_agency.name;
    }

    // Fall back to account's agency name
    if (currentAccount?.belongs_to_agency?.name) {
        return currentAccount.belongs_to_agency.name;
    }

    return 'your agency';
}
